import React from 'react'
import { staticAssetsPath } from '../../../configs/constants'
import { Databox, Document } from '../../../utility/Icons'

const smartDocs = `${staticAssetsPath}/images/smarttools/smartdocs.png`
const smartData = `${staticAssetsPath}/images/smarttools/smartdata.png`

const toolList = [
  {
    id: 'smartDocs',
    name: 'Smart Docs',
    description: 'Transform unstructured data into searchable knowledge',
    icon: smartDocs,
    disabled: false,
    options: [
      {
        id: 1,
        icon: <Databox size={50} color={'#6E6B7B'} />,
        title: 'Entire Databox',
        description: 'Allow Ali access to all documents within a Databox'
      },
      {
        id: 2,
        icon: <Document size={50} color={'#6E6B7B'} />,
        title: 'Selected documents',
        description: 'Specify documents you would like to query'
      }
    ]
  },
  {
    id: 'smartData',
    name: 'Smart Data',
    description: 'Query databases with natural language',
    icon: smartData,
    disabled: true,
    options: []
  }
]

const topicSortOptions = [
  { value: 'relevance', label: 'Relevance' },
  { value: 'date', label: 'Date Added' },
  { value: 'alphabetical', label: 'Alphabetical A-Z' }
]

const responseSchema = {
  id: '',
  content: null,
  copyText: '',
  files: [],
  sources: null, //source of content or data
  suggestions: [],
  sqlQuery: null,
  type: 'text', //text, file, loader, error, modeStart, modeEnd
  timestamp: new Date().getTime()
}

const messageSchema = {
  authorRole: 0, //0=bot, 1=user
  response: [responseSchema],
  avatarVisible: true,
  actionables: []
}

const summaryStyles = [
  {
    query: 'Bullet-point or list summary',
    summaryStyle: 'bullet points'
  },
  {
    query: 'Short summary',
    summaryStyle: 'short'
  },
  {
    query: 'Narrative summary',
    summaryStyle: 'narrative summary'
  }
]

const defaultErrorMsg = `Oops, it seems my virtual gears are having a cozy tea break ☕. Please try again after some time, and I'll be back with a freshly brewed answer for you!`

const tokenExpirerMsg = `It seems we have reached token limit for this conversation. Please start a new conversation to continue.`

const loaderElement = `<div class="dot-pulse dot-pulse-main"></div>`

const dotPulse = '&lt;span class=&quot;single-pulse&quot;/&gt;'

const dotPulseHtml = `<span class="single-pulse"></span>`
const excelFileType =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'

const documentScanMessage = {
  ...messageSchema,
  authorRole: 0,
  response: [
    {
      ...responseSchema,
      content: `I've received your attachments. How can I help?`,
      timestamp: new Date().getTime()
    }
  ]
}

const modeStartMessage = {
  ...messageSchema,
  authorRole: 0,
  response: [
    {
      ...responseSchema,
      type: 'modeStart',
      timestamp: new Date().getTime()
    }
  ]
}

const modeEndMessage = {
  ...messageSchema,
  authorRole: 0,
  response: [
    {
      ...responseSchema,
      type: 'modeEnd',
      timestamp: new Date().getTime()
    }
  ]
}

const getBotLoader = (theme, type) => {
  return type && type === 'text'
    ? loaderElement
    : {
        ...messageSchema,
        response: [
          {
            ...responseSchema,
            content: loaderElement,
            type: 'loader',
            timestamp: new Date().getTime()
          }
        ]
      }
}

const databoxType = [
  { value: 'Personal', label: 'PERSONAL', color: 'info', disabled: true },
  { value: 'Team', label: 'TEAM', color: 'success', disabled: false },
  { value: 'Enterprise', label: 'ENTERPRISE', color: 'primary', disabled: true }
]

const getHeader = (tool, option) => {
  switch (tool) {
    case 'smartDocs':
      switch (option) {
        case 1:
          return 'Databox, hooray!  Time to party...'
        case 2:
          return 'Assemble your A-team of docs! And... buckle up!'
        default:
          return 'SmartDocs it is... Lets do it!'
      }
    case 'smartData':
      switch (option) {
        case 1:
          return 'Gear up and let`s tackle that topic(s) in Cornerstone.'
        case 2:
          return 'Challenge accepted! Upload your CSV.'
        default:
          return 'SmartData bench time is over. Get in the game!'
      }
    default:
      return 'Would you like to chat across..'
  }
}

const conversationStyleOptions = [
  { name: 'Creative', id: 0.7, topP: 0.95, position: 'left' },
  { name: 'Balanced', id: 0.3, topP: 0.5, position: 'center' },
  { name: 'Precise', id: 0, topP: 0.2, position: 'right' }
]

export {
  toolList,
  topicSortOptions,
  defaultErrorMsg,
  documentScanMessage,
  modeStartMessage,
  modeEndMessage,
  messageSchema,
  responseSchema,
  summaryStyles,
  getBotLoader,
  dotPulse,
  dotPulseHtml,
  tokenExpirerMsg,
  databoxType,
  getHeader,
  excelFileType,
  conversationStyleOptions
}
